<template>
    <div class="automation-action-settings">
        <div class="field">
            <label>{{ t('automations-form-actions-coupon-validity_label') }}</label>
            <div class="input-group">
                <input class="form-control" v-model="lifetime" type="tel" />
                <div class="input-group-append">
                    <span class="btn btn-dark">{{ t('automations-form-actions-coupon-validity_unit') }}</span>
                </div>
            </div>
        </div>
        <div class="field">
            <label>
                {{ t('automations-form-actions-coupon-min_wait_label') }}
                <br />
                <small>{{ t('automations-form-actions-coupon-min_wait_help') }}</small>
            </label>
            <div class="input-group">
                <input class="form-control" v-model="tooRecent" type="tel" />
                <div class="input-group-append">
                    <span class="btn btn-dark">{{ t('automations-form-actions-coupon-min_wait_unit') }}</span>
                </div>
            </div>
        </div>
        <div class="field">
            <label>{{ t('automations-form-actions-coupon-calculation_label') }}</label>
            <div>
                <label><input type="radio" v-model="coupon_type" name="coupon_type" value="fixed_amount" />
                    {{ t('automations-form-actions-coupon-calculation_options-fixed_amount') }}
                </label>
                <label><input type="radio" v-model="coupon_type" name="coupon_type" value="percentage" />
                    {{ t('automations-form-actions-coupon-calculation_options-percentage') }}
                </label>
                <label v-show="trigger === 'new_order' ||
                    trigger === 'inactivity' ||
                    trigger === 'order_status_change' ||
                    trigger === 'too_long_on_external_status'
                    ">
                    <input type="radio" v-model="coupon_type" name="coupon_type" value="cashback" />
                    {{ t('automations-form-actions-coupon-calculation_options-cashback') }}
                </label>
                <label><input type="radio" v-model="coupon_type" name="coupon_type" value="other" />
                    {{ t('automations-form-actions-coupon-calculation_options-other') }}
                </label>
            </div>
        </div>
        <div v-show="coupon_type === 'fixed_amount'">
            <div class="field">
                <label>{{ t('automations-form-actions-coupon-discount_label') }}</label>
                <div class="input-group">
                    <div class="input-group-prepend" v-if="!using_snippets.fixed_amount">
                        <span class="btn btn-dark">{{ t('currency_symbol') }}</span>
                    </div>
                    <input v-if="!using_snippets.fixed_amount" class="form-control" name="fixed_amount" v-model="fixed_amount" key="fixed-amount" type="text" v-money="money" />
                    <input v-else class="form-control" name="fixed_amount" v-model="fixed_amount" key="fixed-amount-snippet" type="text" />
                </div>
            </div>
        </div>
        <div class="field" v-if="coupon_type === 'fixed_amount'">
            <div class="input-group px-4">
                <div class="d-flex">
                    <input @change="fixed_amount = using_snippets.fixed_amount ? '' : 0" v-model="using_snippets.fixed_amount" id="check-input-fixed_amount" class="form-check-input" :style="{ 'margin-top': '2.5px' }" type="checkbox" role="switch" />
                    <label class="mb-1" :for="`check-input-fixed_amount`">{{ t('automations-form-actions-coupon-use_snippets_label') }}</label>
                </div>
            </div>
        </div>

        <div v-show="coupon_type === 'percentage'">
            <div class="field">
                <label>{{ t('automations-form-actions-coupon-discount_label') }}</label>
                <div class="input-group">
                    <input v-if="!using_snippets.percentage_discount" class="form-control" name="percentage_discount" v-model="percentage_discount" type="number" min="0" max="100" />

                    <input v-else class="form-control" name="percentage_discount" v-model="percentage_discount" type="text" />

                    <div class="input-group-append" v-if="!using_snippets.percentage_discount">
                        <span class="btn btn-dark">{{ t('percent_symbol') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="field" v-if="coupon_type === 'percentage'">
            <div class="input-group px-4">
                <div class="d-flex">
                    <input @change="percentage_discount = using_snippets.percentage_discount ? '' : 0" v-model="using_snippets.percentage_discount" id="check-input-percentage_discount" class="form-check-input" :style="{ 'margin-top': '2.5px' }" type="checkbox" role="switch" />
                    <label class="mb-1" :for="`check-input-percentage_discount`">{{ t('automations-form-actions-coupon-use_snippets_label') }}</label>
                </div>
            </div>
        </div>

        <div class="field" v-show="coupon_type === 'percentage' || coupon_type === 'fixed_amount'
            ">
            <label>{{ t('automations-form-actions-coupon-min_purchase_label') }}</label>
            <div class="input-group">
                <div class="input-group-prepend" v-if="!using_snippets.min_purchase_value">
                    <span class="btn btn-dark">{{ t('currency_symbol') }}</span>
                </div>
                <input v-if="!using_snippets.min_purchase_value" class="form-control" name="min_purchase_value" v-model="min_purchase_value" key="min-with-money" type="text" v-money="money" />

                <input v-else class="form-control" name="min_purchase_value" v-model="min_purchase_value" key="min-without-money" type="text" />
            </div>
        </div>

        <div class="field" v-if="
            coupon_type === 'percentage' || coupon_type === 'fixed_amount'
        ">
            <div class="input-group px-4">
                <div class="d-flex">
                    <input @change="min_purchase_value = using_snippets.min_purchase_value ? '' : 0" v-model="using_snippets.min_purchase_value" id="check-input-min_purchase_value" class="form-check-input" :style="{ 'margin-top': '2.5px' }" type="checkbox" role="switch" />
                    <label class="mb-1" :for="`check-input-min_purchase_value`">{{ t('automations-form-actions-coupon-use_snippets_label') }}</label>
                </div>
            </div>
        </div>
        <div v-show="coupon_type === 'cashback'">
            <div class="field">
                <label>{{ t('automations-form-actions-coupon-cashback_percentage_label') }}</label>
                <div class="input-group">
                    <input class="form-control" name="percentage_discount" v-model="cashback_percentage" type="number" min="0" max="100" />
                    <div class="input-group-append">
                        <span class="btn btn-dark">{{ t('percent_symbol') }}</span>
                    </div>
                </div>
            </div>
            <div class="field">
                <label>{{ t('automations-form-actions-coupon-cashback_max_discount_label') }}</label>
                <div class="input-group">
                    <input class="form-control" name="max_discount" v-model="max_discount" type="number" min="0" max="100" />
                    <div class="input-group-append">
                        <span class="btn btn-dark">{{ t('percent_symbol') }}</span>
                    </div>
                </div>
            </div>
            <div>
                <p>
                    <small v-html="t('automations-form-actions-coupon-cashback_example_text', [formatNumber(order_example_value), formatNumber(computedCashback), formatNumber(computedCashbackMinPurchaseValue)])">
                    </small>
                </p>
            </div>
        </div>
        <div class="field" v-show="coupon_type === 'other'">
            <label>{{ t('automations-form-actions-coupon-description_label') }}</label>
            <div>
                <input class="form-control" name="description" v-model="coupon_description" />
            </div>
        </div>

        <small>
            {{ t('automations-form-actions-coupon-snippets_help') }}
        </small>
        <small>
            <ul>
                <li class="token" v-for="(token, t) in tokens" :key="t">
                    <span class="copy-token">{{ token }}</span>
                    <a @click="copyToken(token)" class="copy-btn"><i class="fa fa-copy"></i></a>
                </li>
            </ul>
        </small>
    </div>
</template>
<style scoped>
strong {
    font-weight: 500;
}
</style>
<script>
export default {
    props: {
        properties: Object,
        conditions: Array,
    },
    data: function () {
        return {
            title: this.t("automations-form-actions-coupon-title"),
            coupon_type: this.properties.coupon_type
                ? this.properties.coupon_type
                : "fixed_amount",
            description: this.t("automations-form-actions-coupon-description"),
            coupon_description: this.properties.coupon_description
                ? this.properties.coupon_description
                : "",
            lifetime: this.properties.lifetime ? this.properties.lifetime : 14,
            tooRecent: this.properties.tooRecent
                ? this.properties.tooRecent
                : 16,
            fixed_amount: this.properties.fixed_amount
                ? this.properties.fixed_amount
                : 0,
            percentage_discount: this.properties.percentage_discount
                ? this.properties.percentage_discount
                : 0,
            cashback_percentage: this.properties.cashback_percentage
                ? this.properties.cashback_percentage
                : 0,
            max_discount: this.properties.max_discount
                ? this.properties.max_discount
                : 0,
            min_purchase_value: this.properties.min_purchase_value
                ? this.properties.min_purchase_value
                : 0,
            order_example_value: 200,
            money: {
                decimal: ".",
                thousands: "",
                prefix: "",
                suffix: "",
                precision: 2,
            },
            using_snippets: {
                min_purchase_value: !!this.properties.using_snippets?.min_purchase_value,
                percentage_discount: !!this.properties.using_snippets?.percentage_discount,
                fixed_amount: !!this.properties.using_snippets?.fixed_amount,
            }
        };
    },
    mounted: function () {
        this.$emit("mounted", this);
        this.$nextTick(() => {
            this.changed();
        });
    },
    computed: {
        tokens: function () {
            return this.$store.getters["automationForm/tokens"](this.actionId);
        },
        trigger: function () {
            return this.$store.state.automationForm.trigger;
        },
        computedCashback: function () {
            return this.order_example_value * (this.cashback_percentage / 100);
        },
        computedCashbackMinPurchaseValue: function () {
            if (!this.max_discount) {
                return 0;
            }
            const discount = this.computedCashback;
            return discount / (this.max_discount / 100);
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        copyToken(token) {
            const input = document.createElement("input");
            input.value = token;
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input);

            this.$store.dispatch("notification/success", {
                text: this.t("automations-form-actions-coupon-token_copied"),
                duration: 5000,
            });
        },
        formatNumber(number) {
            return parseFloat(number).toLocaleString("pt-BR");
        },
        computeDescription() {
            if (this.coupon_type === "cashback") {
                this.description = "[[]]";
            } 
        },
        isValid: function () {
            return true;
        },
        changed: function () {
            this.$emit("propertiesUpdated", {
                lifetime: this.lifetime,
                tooRecent: this.tooRecent,
                fixed_amount: this.fixed_amount,
                percentage_discount: this.percentage_discount,
                cashback_percentage: this.cashback_percentage,
                max_discount: this.max_discount,
                min_purchase_value: this.min_purchase_value,
                coupon_type: this.coupon_type,
                coupon_description: this.coupon_description,
                using_snippets: this.using_snippets,
            });
        },
    },
    watch: {
        coupon_type: function () {
            this.changed();
        },
        coupon_description: function () {
            this.changed();
        },
        lifetime: function () {
            this.changed();
        },
        tooRecent: function () {
            this.changed();
        },
        fixed_amount: function () {
            this.changed();
        },
        percentage_discount: function () {
            this.changed();
        },
        cashback_percentage: function () {
            this.changed();
        },
        max_discount: function () {
            this.changed();
        },
        min_purchase_value: function () {
            this.changed();
        },
        using_snippets: {
            handler() {
                this.changed();
            },
            deep: true
        }
    },
};
</script>
